module.exports = __webpack_public_path__ + "img/823.a7f2d835.png";